import { connect } from 'react-redux';
import { fetchSuggestedCreatives, selectCreative } from 'project/ducks/project_1_1';
import SuggestedCreatives from 'project/components/brief/suggested_creatives_1_1';

const mapStateToProps = (state) => {
  const project1To1 = state.project.projectPage.project1To1
  return {
    isFetching: project1To1.isFetching,
    creatives: project1To1.suggestedCreatives,
    selectedCreative: project1To1.selectedCreative
  }
}

export default connect(mapStateToProps, {
  fetchSuggestedCreatives,
  selectCreative
})(SuggestedCreatives);



// WEBPACK FOOTER //
// ./project/containers/suggested_creatives_1_1.jsx